function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14.73 14.73",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.73 13.88L10.82 10a6.09 6.09 0 001.38-3.9A6.11 6.11 0 006.1 0 6.11 6.11 0 000 6.1a6 6 0 001.79 4.31 6.1 6.1 0 008.18.41l3.91 3.91zM2.64 9.56A4.9 4.9 0 016.1 1.2a4.89 4.89 0 013.46 8.36 4.88 4.88 0 01-6.92 0z"
})));